import { render, staticRenderFns } from "./StdItemTxtForm.vue?vue&type=template&id=65f62934&"
import script from "./StdItemTxtForm.vue?vue&type=script&lang=js&"
export * from "./StdItemTxtForm.vue?vue&type=script&lang=js&"
import style0 from "./StdItemTxtForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdItemTxtForm.vue"
export default component.exports